module.exports = __webpack_public_path__ + "static/img/badgruen.22968c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/handwerk/badgruen.jpg
// module id = ZcYF
// module chunks = 1